import { html } from 'lit';
import { createElement, AlertCircle } from 'lucide';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-alert-circle')
export class PdsIconAlertCircle extends PdsIcon {
  createIconElement(): SVGElement {
    return createElement(AlertCircle);
  }

  render() {
    return html`${this.icon}`;
  }
}
